import type { SVGProps } from 'react';

export const FormatUnderlined = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.1 20.125a.799.799 0 0 1-.55-.2.798.798 0 0 1-.2-.55.71.71 0 0 1 .2-.525.748.748 0 0 1 .55-.225h11.8c.217 0 .392.075.525.225.15.133.225.308.225.525 0 .217-.075.4-.225.55a.71.71 0 0 1-.525.2H6.1Zm5.9-3.6c-1.55 0-2.767-.467-3.65-1.4-.867-.95-1.3-2.217-1.3-3.8v-7a.81.81 0 0 1 .275-.625.889.889 0 0 1 .65-.275c.267 0 .483.092.65.275a.81.81 0 0 1 .275.625V11.4c0 1.017.267 1.833.8 2.45.55.6 1.317.9 2.3.9.983 0 1.742-.3 2.275-.9.55-.617.825-1.433.825-2.45V4.325a.81.81 0 0 1 .275-.625.889.889 0 0 1 .65-.275.89.89 0 0 1 .65.275.81.81 0 0 1 .275.625v7c0 1.583-.442 2.85-1.325 3.8-.867.933-2.075 1.4-3.625 1.4Z" />
    </svg>
  );
};
